import { createClient } from '@supabase/supabase-js';

// Helper to safely get environment variables without crashing
export const getEnv = (key: string) => {
  // 1. Try process.env (Standard Node/Vercel)
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }

  // 2. Try import.meta.env (Vite) safely
  try {
    // @ts-ignore
    const meta = import.meta as any;
    if (meta && meta.env && meta.env[key]) {
      return meta.env[key];
    }
  } catch (e) {
    // Ignore errors if import.meta is not available
  }

  return '';
};

// More aggressive check for keys to prevent "undefined" errors
// We prioritize VITE_ prefixes because Vercel exposes them to the client side
const getSupabaseConfig = () => {
    const url = getEnv('VITE_SUPABASE_URL') || getEnv('SUPABASE_URL');
    const key = getEnv('VITE_SUPABASE_ANON_KEY') || getEnv('SUPABASE_ANON_KEY');
    return { url, key };
}

const { url: supabaseUrl, key: supabaseAnonToken } = getSupabaseConfig();

if (!supabaseUrl || !supabaseAnonToken) {
    // Only log this in the browser to avoid cluttering build logs
    if (typeof window !== 'undefined') {
        console.warn("Supabase URL or Key missing. Authentication will fail.");
        console.warn("Check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY settings.");
    }
}

// Create the Supabase client
// We use a placeholder if keys are missing during build time to prevent build crashes
export const supabase = createClient(
    supabaseUrl || 'https://placeholder.supabase.co', 
    supabaseAnonToken || 'placeholder'
);